import Vue from 'vue';

export default Vue.component('edit-divider', {
  template: require('./template.html'),
  name: 'edit-divider',
  props: ['droplet', 'show-edit-bubble'],
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/divider/components/_edit-options/index.js